import { UploadFileStatus, type UploadFileInfo } from '@progress/kendo-react-upload'

export const toBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export const getFileExtension = (fileName: string): string => {
  const extensionStart = fileName.lastIndexOf('.')
  return extensionStart >= 0 ? fileName.slice(extensionStart) : ''
}

export const toUploadFileInfo = (file: File, uid: string): UploadFileInfo => ({
  uid,
  name: file.name,
  extension: getFileExtension(file.name),
  size: file.size,
  status: UploadFileStatus.Selected,
  progress: 0,
  getRawFile: () => file,
})
